import request from "@/utils/request";

// 保存和修改广告内容配置
export function positionSettingSave(data) {
  return request({
    url: `/advertisement/positionSetting/saveOrUpdate`,
    method: "post",
    data: data,
  });
}

// 查询广告位下拉列表
export function positionSettingGetList(data) {
  return request({
    url: `/advertisement/positionSetting/list`,
    method: "get",
    params: data,
  });
}
// 查询广告位分页
export function positionSettingGetPage(data) {
  return request({
    url: `/advertisement/positionSetting/page`,
    method: "get",
    params: data,
  });
}

//   根据id查询广告位详情
export function positionSettingGetInfo(id) {
  return request({
    url: `/advertisement/positionSetting/info/${id}`,
    method: "get",
  });
}

// 启用停用广告位置
export function positionSettingEnable(data) {
  return request({
    url: `/advertisement/positionSetting/enable`,
    method: "get",
    params: data,
  });
}

// 删除广告位
export function positionSettingDelete(id) {
  return request({
    url: `/advertisement/positionSetting/delete/${id}`,
    method: "DELETE",
  });
}

//   /contentManagement/saveOrUpdate
// 新增修改广告内容
export function contentManagementSave(data) {
  return request({
    url: `/advertisement/contentManagement/saveOrUpdate`,
    method: "post",
    data: data,
  });
}

// 查询广告内容分页
export function contentManagementGetPage(data) {
  return request({
    url: `/advertisement/contentManagement/page`,
    method: "POST",
    data: data,
  });
}

// 查询广告内容详情
export function contentManagementGetInfo(id) {
  return request({
    url: `/advertisement/contentManagement/info/${id}`,
    method: "get",
  });
}

// /contentManagement/publishOrRemoval
// 发布、下架广告内容
export function publishOrRemoval(data) {
  return request({
    url: `/advertisement/contentManagement/publishOrRemoval`,
    method: "get",
    params: data,
  });
}

// 删除广告内容
export function contentManagementDelete(id) {
  return request({
    url: `/advertisement/contentManagement/delete/${id}`,
    method: "DELETE",
  });
}

// 获取商品详情
// goodsBaseDetail

export function getCompGoodsBaseDetail(data) {
  return request({
    url: "/product/compliance/goodsbase/getCompGoodsBaseDetail",
    method: "get",
    params: data,
  });
}
// 新增广告-活动
export function addActivity(data) {
  return request({
    url: `/product/adActivity/add`,
    method: "post",
    data: data,
  });
}
// 广告活动-列表
export function activityList(data) {
  return request({
    url: `/product/adActivity/page`,
    method: "get",
    params: data,
  });
}
// 保存新增的商品
export function addActivityGoods(data) {
  return request({
    url: `/product/adActivity/addActivityGoods`,
    method: "post",
    data: data,
  });
}
// 已选商品查询
export function getGoodsByActivityId(data) {
  return request({
    url: `/product/adActivity/getGoodsByActivityId`,
    method: "get",
    params: data,
  });
}
// 修改活动信息序号｜名称
export function updateActivity(data) {
  return request({
    url: `/product/adActivity/patch/${data.id}`,
    method: "patch",
    data: data,
  });
}
// 删除活动
export function deleteActivity(data) {
  return request({
    url: `/product/adActivity/delete/${data.id}`,
    method: "delete",
    data: data,
  });
}
